import { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Loader from '../common/components/customized/customloader/CustomLoader';
import Reports from '../features/yaantrac/pages/reports/Reports';
import DispatchManagement from '../features/truckmanagement/pages/configurations/DispatchManagement';
import Logistics from '../features/truckmanagement/pages/configurations/accounts/Logistics';
import Trucks from '../features/truckmanagement/pages/configurations/truck-zone/Trucks';
import Dispatch from '../features/truckmanagement/pages/trips/dispatch/Dispatch';
import { useAppSelector } from '../app/redux/hooks';
import Inspection from '../features/truckmanagement/pages/inspection/Inspection';
import Maintenance from '../features/truckmanagement/pages/maintenance/Maintenance';
import TripsManagement from '../common/pages/user/trips/TripsManagement';
import AutoPlanner from '../features/autoplanner/pages/trips/bookings/AutoPlanner';
import Configuration from '../common/pages/user/configuration/Configuration';
import Geofence from '../common/pages/user/configuration/components/geofence/Geofence';
import Driver from '../common/pages/user/configuration/components/driver/Driver';
import OverSpeed from '../common/pages/user/configuration/components/overspeed/OverSpeed';
import RouteConfiguration from '../features/autoplanner/pages/configurations/tour/RouteConfiguration';
import VehicleConfiguration from '../features/autoplanner/pages/configurations/vehicleconfiguration/VehicleConfiguration';
import App from '../features/autoplanner/pages/configurations/agents/agents';
import LogisticsDispatch from '../features/truckmanagement/pages/trips/LogisticsDispatch';
import DeliveryTracking from '../common/pages/deliverytracking/trips/deliverytracking/DeliveryTracking';
import CustomerDelivery from '../features/deliverytracking/pages/configurations/customerdelivery/CustomerDelivery';
import AutoPlannerTrip from '../features/autoplanner/pages/trips/bookings/AutoPlannerTrip';
import AutoGenerateView from '../features/autoplanner/pages/trips/scheduled/AutoGenerateView';
import Notifications from '../features/yaantrac/pages/notifications/Notifications';
import HistoryNotifications from '../features/yaantrac/pages/notifications/HistoryNotifications';
import PickupLocations from '../features/autoplanner/pages/configurations/locations/PickupLocations';
import DeliveryCustomerCard from '../features/deliverytracking/pages/configurations/customdeliverycard/DeliveryCustomerCard';
import CustomExcelLoader from '../common/components/customExcelLoader/CustomExcelLoader';
import InspectionView from '../features/truckmanagement/pages/trips/dispatch/InspectionView';
import AvailableTourSummary from '../features/autoplanner/pages/trips/summary/AvailableTourSummary';
import MyTrips from '../features/yaantrac/pages/trips/MyTrips';
import MapView from '../features/autoplanner/pages/trips/scheduled/MapView';
import DeliveryTrips from '../features/deliverytracking/pages/trips/DeliveryTrips';
import DeliveryTripsManagement from '../common/pages/user/trips/DeliveryTripsManagement';

import TodayTours from '../features/autoplanner/pages/trips/scheduled/TodayTours';
import VehicleOnboard from '../features/autoplanner/pages/configurations/vehicleconfiguration/VehicleOnboard';
import Loads from '../features/deliverytracking/pages/loads/Loads';

import RegularMode from '../features/autoplanner/pages/configurations/regular/RegularMode';
import DispatchTracking from '../features/deliverytracking/pages/dispatch/components/DispatchTracking';
import AddDispatch from '../features/truckmanagement/pages/trips/dispatch/AddDispatch';
import DispatchView from '../features/deliverytracking/pages/dispatch/components/DispatchView';
import GeofenceMapping from '../features/yaantrac/pages/geofence/components/GeofenceMapping';

import { Agent } from 'http';

import Roles from '../common/pages/roles/Roles';
import Users from '../features/autoplanner/pages/trips/Users';
import OperationTeam from '../features/autoplanner/pages/trips/OperationTeam';

const Help = lazy(() => import('../common/pages/user/settings/help/Help'));
// const Analytics = lazy(() => import('../pages/user/analytics/Analytics'));
// const DeliveryAnalytics = lazy(() => import('../pages/user/analytics/DeliveryAnalytics'));
const LiveTracking = lazy(
  () => import('../features/yaantrac/pages/livetracking/LiveTracking')
);
const HistoricTracking = lazy(
  () => import('../features/yaantrac/pages/historic-tracking/HistoricTracking')
);
const Management = lazy(() => import('../common/pages/user/management/Management'));
const Dashboard = lazy(() => import('../features/yaantrac/pages/dashboard/Dashboard'));
const OverviewDashboard = lazy(
  () => import('../features/yaantrac/pages/dashboard/OverviewDashboard')
);
const Trips = lazy(() => import('../features/deliverytracking/pages/trips/Trips'));
const Orders = lazy(
  () => import('../features/deliverytracking/pages/trips/orders/Orders')
);
const OrderDetails = lazy(
  () => import('../common/pages/deliverytracking/orderdetails/OrderDetails')
);
const ViewOrders = lazy(
  () => import('../features/deliverytracking/pages/trips/orders/ViewOrders')
);
const VehicleConfigManager = lazy(
  () =>
    import('../features/truckmanagement/pages/vehicleconfig-manager/VehicleConfigManager')
);

const DeliveryOrders = lazy(
  () => import('../features/deliverytracking/pages/orders/DeliveryOrders')
);
const AddOrders = lazy(
  () => import('../features/deliverytracking/pages/orders/components/AddDeliveryOrders')
);
const DeliveryDispatch = lazy(
  () => import('../features/deliverytracking/pages/dispatch/Dispatch')
);
const DeliveryAddDispatch = lazy(
  () => import('../features/deliverytracking/pages/dispatch/components/AddDispatch')
);

const DeliveryDispatchView = lazy(
  () => import('../features/deliverytracking/pages/dispatch/components/DispatchView')
);

const Load = lazy(() => import('../features/deliverytracking/pages/loads/Loads'));
const LoadConfig = lazy(
  () => import('../features/deliverytracking/pages/loadConfig/LoadConfig')
);
const AddDeliveryLoads = lazy(
  () => import('../features/deliverytracking/pages/loads/AddDeliveryLoads')
);
function PrivateRoutes() {
  const { data } = useAppSelector(state => state.auth);
  const { category } = useAppSelector(state => state.RoleModuleAccess);

  let roletype = data?.role;

  const APagent = roletype === 'ROLE_AGENT';
  const APsubAgents = roletype === 'ROLE_SUB_AGENT';
  const deliveryTracking = roletype === 'ROLE_DT_ADMIN';
  const APsuperAdmin = roletype === 'ROLE_AUTOPLANNER_ADMIN';
  const APoperator = roletype === 'ROLE_OPERATOR';
  const logistics = roletype === 'ROLE_LOGISTICS_ADMIN';

  return (
    <Suspense fallback={<Loader />}>
      {APagent || APsubAgents ? (
        <Routes>
          <Route path='*' element={<Navigate to='/today-trips' />} />
          <Route path='/today-trips' element={<TodayTours />} />
          <Route path='/trips' element={<TripsManagement />}>
            <Route path='autoplannertrips' element={<AutoPlanner />}>
              <Route path='tours' element={<AutoPlannerTrip />} />
              <Route path='scheduled-tour' element={<AutoGenerateView />} />
            </Route>
          </Route>
          {!APsubAgents && <Route path='/configuration/agents' element={<App />} />}
        </Routes>
      ) : deliveryTracking ? (
        <Routes>
          <Route path='*' element={<Navigate to='/deliveryorders' />} />
          <Route path='/deliveryload' element={<Load />} />

          <Route path='/deliveryorders' element={<DeliveryOrders />} />
          <Route path='/addorders' element={<AddOrders />} />
          <Route path='/deliverytracking' element={<DeliveryTracking />}>
            <Route path='customerdelivery' element={<CustomerDelivery />} />
            <Route path='deliverytrackingtrips' element={<Trips />} />
          </Route>
          <Route path='/deliverytripsmanagment' element={<DeliveryTripsManagement />}>
            <Route path='deliverytrips' element={<DeliveryTrips />} />
          </Route>
          <Route path='/trips' element={<TripsManagement />}>
            <Route path='deliverytrackingtrips' element={<Trips />} />
          </Route>

          <Route path='/deliveryload-form' element={<AddDeliveryLoads />} />
          {/* <Route path='newdelivery' element={<NewDelivery />} /> */}
          {/* </Route> */}
          <Route path='/configuration' element={<Configuration />}>
            <Route path='driver' element={<Driver />} />
            <Route path='vehicles' element={<OverSpeed />} />
            <Route path='loadconfig' element={<LoadConfig />} />
          </Route>
          <Route path='/dispatch' element={<DeliveryDispatch />} />
          <Route path='/adddispatch' element={<DeliveryAddDispatch />} />
          <Route path='/dispatchtracking' element={<DispatchTracking />} />
          <Route path='/dispatchview' element={<DeliveryDispatchView />} />
        </Routes>
      ) : APsuperAdmin || APoperator || category === 'OPERATION_USER' ? (
        <Routes>
          <Route path='*' element={<Navigate to='/today-trips' />} />
          <Route path='/today-trips' element={<TodayTours />} />
          <Route path='/trips' element={<TripsManagement />}>
            <Route path='autoplannertrips' element={<AutoPlanner />}>
              <Route path='tours' element={<AutoPlannerTrip />} />
              <Route path='tour-summary' element={<AvailableTourSummary />} />
              <Route path='scheduled-tour' element={<AutoGenerateView />} />
            </Route>
          </Route>

          <Route path='/users' element={<Users />}>
            <Route path='operationteam' element={<OperationTeam />} />
            <Route path='company' element={<App />} />
            <Route path='roles' element={<Roles />} />
          </Route>
          <Route path='/configuration' element={<Configuration />}>
            <Route path='driver' element={<Driver />} />

            <Route path='roles' element={<Roles />} />

            <Route path='routeconfiguration' element={<RouteConfiguration />} />
            <Route path='regular' element={<RegularMode />} />
            <Route path='vehicleconfiguration' element={<VehicleOnboard />} />
            <Route path='pickupLocations' element={<PickupLocations />} />

            {!APoperator && <Route path='agents' element={<App />} />}
          </Route>
          <Route path='/management' element={<Management />}>
            <Route path='reports' element={<Reports />} />
            <Route path='agents' element={<App />} />
            <Route path='accounts' element={<Logistics />} />
          </Route>
        </Routes>
      ) : logistics ? (
        <Routes>
          <Route path='*' element={<Navigate to='/trips' />} />
          <Route path='/trips' element={<TripsManagement />}>
            <Route path='logistics' element={<LogisticsDispatch />} />
          </Route>
          <Route path='/management' element={<Management />}>
            <Route path='inspection' element={<Inspection />} />
            <Route path='maintenance' element={<Maintenance />} />
            <Route path='vehicle-config-manager' element={<VehicleConfigManager />} />
          </Route>
          <Route path='/inspectionview' element={<InspectionView />} />
          <Route path='/configuration' element={<Configuration />}>
            <Route path='driver' element={<Driver />} />
            <Route path='vehicles' element={<OverSpeed />} />
            <Route path='truck-zone' element={<Trucks />} />
            <Route path='accounts' element={<Logistics />} />
          </Route>
        </Routes>
      ) : roletype ? (
        <Routes>
          {/* <Route path='/dashboard' element={<Analytics />} /> */}
          {/* <Route path='/dashboard2' element={<DeliveryAnalytics />} /> */}
          <Route path='*' element={<Navigate to='/dashboard' />} />
          <Route path='/livetracking' element={<LiveTracking />} />
          <Route path='/help' element={<Help />} />
          <Route path='/management' element={<Management />}>
            <Route path='reports' element={<Reports />} />
            <Route path='inspection' element={<Inspection />} />
            <Route path='maintenance' element={<Maintenance />} />
            <Route path='vehicle-config-manager' element={<VehicleConfigManager />} />
          </Route>

          <Route path='/trips' element={<TripsManagement />}>
            <Route path='mytrips' element={<MyTrips />} />
            {/* <Route path='autoplannertrips' element={<AutoPlanner />}>
              <Route path='tours' element={<AutoPlannerTrip />} />
              <Route path='tour-summary' element={<AvailableTourSummary />} />
              <Route path='scheduled-tour' element={<AutoGenerateView />} />
              <Route path='/auto-generate' element={<AutoGenerateView />} />
              <Route path='/map-view/:autoplannerId' element={<MapView />} />
            </Route> */}
            <Route path='logistics' element={<LogisticsDispatch />} />
            <Route path='deliverytrackingtrips' element={<Trips />} />
          </Route>
          <Route path='/dispatch-management' element={<DispatchManagement />}>
            <Route path='logistics' element={<Logistics />} />
            <Route path='truck-zone' element={<Trucks />} />
            <Route path='loads' element={<Loads />} />
            <Route path='dispatchs' element={<Dispatch />} />
            <Route path='inspection' element={<Inspection />} />
            <Route path='maintenance' element={<Maintenance />} />
          </Route>
          <Route path='/historynotifications' element={<HistoryNotifications />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/historictracking' element={<HistoricTracking />} />
          <Route path='/overviewdashboard' element={<OverviewDashboard />} />

          <Route path='/orderdetails' element={<OrderDetails />} />
          {/* <Route path='/orders' element={<Orders />} /> */}
          {/* <Route path='/vieworders' element={<ViewOrders />} /> */}
          <Route path='/inspectionview' element={<InspectionView />} />
          <Route path='/configuration' element={<Configuration />}>
            <Route path='geofence' element={<Geofence />} />
            {/* <Route path='customerdelivery' element={<CustomerDelivery />} /> */}
            <Route path='customerdelivery' element={<DeliveryCustomerCard />} />
            <Route path='driver' element={<Driver />} />
            <Route path='vehicles' element={<OverSpeed />} />
            <Route path='truck-zone' element={<Trucks />} />
            <Route path='routeconfiguration' element={<RouteConfiguration />} />
            <Route path='vehicleconfiguration' element={<VehicleConfiguration />} />
            <Route path='pickupLocations' element={<PickupLocations />} />
            <Route path='agents' element={<App />} />
            <Route path='accounts' element={<Logistics />} />
          </Route>
          <Route path='/geofencemapping' element={<GeofenceMapping />} />
        </Routes>
      ) : (
        <></>
      )}
      <CustomExcelLoader />
    </Suspense>
  );
}

export default PrivateRoutes;
